// extracted by mini-css-extract-plugin
export var stepActive = "_21-3";
export var stepCompleted = "_21-4";
export var stepConnectorLine = "_21-b";
export var stepIndicatorCircle = "_21-6";
export var stepIndicatorCircleCompleted = "_21-7";
export var stepIndicatorCircleDefault = "_21-8";
export var stepIndicatorTextCompleted = "_21-9";
export var stepIndicatorTextDefault = "_21-a";
export var stepPending = "_21-5";
export var wizardContainer = "_21-1";
export var wizardContent = "_21-2";
export var wizardModal = "_21-0";